interface SanitizeFileName {
	parts: string[];
	separator?: string;
	replacement?: string;
}

const illegalRe = /[/?<>\\:*|"]/g;
// eslint-disable-next-line no-control-regex
const controlRe = /[\x00-\x1f\x80-\x9f]/g;
const reservedRe = /^\.+$/;
const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
const windowsTrailingRe = /[. ]+$/;

const sanitizeFileName = ({
	parts,
	separator = '-',
	replacement = '',
}: SanitizeFileName) => {
	const sanitizedParts = parts.map(part => {
		return part
			.replace(illegalRe, replacement)
			.replace(controlRe, replacement)
			.replace(reservedRe, replacement)
			.replace(windowsReservedRe, replacement)
			.replace(windowsTrailingRe, replacement)
			.replace(/[\s]+/g, separator)
			.toLowerCase();
	});

	return sanitizedParts.join(separator);
};

export { sanitizeFileName };
